// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.kraken",
    name: "Kraken Wallet ",
    homepage: "https://www.kraken.com/wallet",
    image_id: "8909e826-63e4-42b3-60b2-8a6a54060900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/kraken-wallet/id1626327149",
        android: "https://play.google.com/store/apps/details?id=com.kraken.superwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "krakenwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map